// src/services/itemTypeService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getItemTypes = async () => {
  return await axios.get(`${API_URL}/items_type/`);
};

const getItemType = async (id) => {
  return await axios.get(`${API_URL}/items_type/${id}`);
};

const createItemType = async (itemTypeData) => {
  return await axios.post(`${API_URL}/items_type/`, itemTypeData);
};

const updateItemType = async (id, itemTypeData) => {
  return await axios.put(`${API_URL}/items_type/${id}`, itemTypeData);
};

const deleteItemType = async (id) => {
  return await axios.delete(`${API_URL}/items_type/${id}`);
};

export default {
  getItemTypes,
  getItemType,
  createItemType,
  updateItemType,
  deleteItemType,
};
